import {EnumSkupinaPrenosDtm} from '../api';

export const enumSkupinaPrenosDtm: string[] = Object.keys(EnumSkupinaPrenosDtm);

export const getEnumSkupinaPrenosDtmCaption = (typ: string | (typeof EnumSkupinaPrenosDtm)[keyof typeof EnumSkupinaPrenosDtm]): string => {
    switch (typ) {
        case EnumSkupinaPrenosDtm.PODPERNA:
            return 'Podpěrná';
        case EnumSkupinaPrenosDtm.ELEKTRICKA:
            return 'Elektrická';
        case EnumSkupinaPrenosDtm.VODOVODNI:
            return 'Vodovodní';
        case EnumSkupinaPrenosDtm.SDILENE:
            return 'Sdílené';
        case EnumSkupinaPrenosDtm.PLYNOVOD:
            return 'Plynovod';
        case EnumSkupinaPrenosDtm.OCHRANNE:
            return 'Ochranné';
        default:
            return `_${typ}`;
    }
};

type EnumSkupinaPrenosDtmProps = {id: EnumSkupinaPrenosDtm; name: string};

export const getEnumSkupinaPrenosDtmItems = (): EnumSkupinaPrenosDtmProps[] => {
    return enumSkupinaPrenosDtm.map((t: EnumSkupinaPrenosDtm): EnumSkupinaPrenosDtmProps => ({id: t, name: getEnumSkupinaPrenosDtmCaption(t)}));
};
